import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const articleHeaderSchema = {
    componentId: "ArticleHeader",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Headline", type: "text" },
        { key: "category", label: "Category", type: "text" },
        { key: "date", label: "Date", type: "text" },
        { key: "topic", label: "Topic", type: "text" },
        { key: "location", label: "Dateline location", type: "text" },
        { key: "source", label: "Source", type: "text" },
        { key: "sourceUrl", label: "Original article URL", type: "url" },
        {
            key: "summary",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Summary",
            type: "textarea",
        },
    ],
    mediaSlots: [
        {
            key: "image",
            label: "Lead image",
            targets: [
                { width: 700, height: 525, aspectRatio: "4:3" },
                { width: 1132, height: 590, aspectRatio: "1132:590" },
            ],
        },
    ],
};
//# sourceMappingURL=article-header.js.map